export default __webpack_public_path__ + "static/media/ThunderRiver.6ad91f74.jpg";